import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleOrderType } from './data';
import { applySettle, backOrder, cancelOrder, createOrder, editOrder, getOrderPage, saveOrderFiles, sendOrder } from './service';

export type OrderState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleOrderType[];
};

type OrderModelType = {
  namespace: string;
  state: OrderState;
  reducers: {
    OrderReducer: Reducer<OrderState>;
  };
  effects: {
    fetchOrderPageEffect: Effect;
    refreshDataEffect: Effect;
    sendOrderEffect: Effect;
    backOrderEffect: Effect;
    applySettleEffect: Effect;
    cancelOrderEffect: Effect;
    saveOrderFilesEffect: Effect;
    createOrderEffect: Effect;
    editOrderEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const OrderModel: OrderModelType = {
  namespace: 'order',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    OrderReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as OrderState;
    },
  },

  effects: {
    *fetchOrderPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getOrderPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'OrderReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.order.current);
      const pageSize = yield select((state: any) => state.order.pageSize);
      yield put({
        type: 'fetchOrderPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 发货
    sendOrderEffect: createEffect(sendOrder),
    // 回收
    backOrderEffect: createEffect(backOrder),
    // 申请结算
    applySettleEffect: createEffect(applySettle),
    // 取消订单
    cancelOrderEffect: createEffect(cancelOrder),
    // 保存订单文件
    saveOrderFilesEffect: createEffect(saveOrderFiles),
    // 创建订单
    createOrderEffect: createEffect(createOrder),
    // 编辑订单
    editOrderEffect: createEffect(editOrder),
  },

  subscriptions: {
    setup() {},
  },
};

export default OrderModel;
